import "./AccreditedBy.css";

import iacpLogo from "../../images/iacp-logo-white.jpg";

const AccreditedBy = () => {
  return (
    <section className="accredited-by">
      <div className="accredited-by-title-text">Accredited by:</div>
      <div>
        <a href="https://iacp.ie/" target="_blank" rel="noreferrer">
          <img width="300px" src={iacpLogo} alt="IACP" />
        </a>
      </div>
    </section>
  );
};

export default AccreditedBy;
